import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_empty_state = _resolveComponent("empty-state")

  return (_openBlock(), _createBlock(_component_empty_state, { title: $props.title }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title"]))
}